(function () {
  var instagramScriptPromise = null;
  var soundStorageKey = 'grt-reel-sound-enabled';

  function readStoredSoundPreference() {
    try {
      return window.localStorage.getItem(soundStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function writeStoredSoundPreference(isEnabled) {
    try {
      window.localStorage.setItem(soundStorageKey, isEnabled ? 'true' : 'false');
    } catch (error) {}
  }

  function loadInstagramEmbeds() {
    if (window.instgrm && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === 'function') {
      return Promise.resolve(window.instgrm);
    }

    if (instagramScriptPromise) return instagramScriptPromise;

    instagramScriptPromise = new Promise(function (resolve, reject) {
      var existingScript = document.getElementById('grt-instagram-embed-script');

      if (existingScript) {
        existingScript.addEventListener('load', function () {
          resolve(window.instgrm);
        });
        existingScript.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.id = 'grt-instagram-embed-script';
      script.async = true;
      script.src = 'https://www.instagram.com/embed.js';
      script.onload = function () {
        resolve(window.instgrm);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return instagramScriptPromise;
  }

  function processInstagramEmbeds(root) {
    if (!root.querySelector('[data-grt-instagram-embed]')) return;

    loadInstagramEmbeds()
      .then(function (instgrm) {
        if (instgrm && instgrm.Embeds && typeof instgrm.Embeds.process === 'function') {
          instgrm.Embeds.process();
        }
      })
      .catch(function () {});
  }

  function setVideoPlayback(video, shouldPlay, shouldMute) {
    if (!video) return;

    video.loop = true;
    video.playsInline = true;
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.volume = 1;

    if (shouldMute) {
      video.defaultMuted = true;
      video.muted = true;
      video.setAttribute('muted', '');
    } else {
      video.defaultMuted = false;
      video.muted = false;
      video.removeAttribute('muted');
    }

    if (shouldPlay) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          if (shouldMute) return;

          video.defaultMuted = true;
          video.muted = true;
          video.setAttribute('muted', '');

          var fallbackPlayPromise = video.play();
          if (fallbackPlayPromise && typeof fallbackPlayPromise.catch === 'function') {
            fallbackPlayPromise.catch(function () {});
          }
        });
      }
      return;
    }

    video.pause();
  }

  function attemptGesturePlay(video, shouldMute) {
    if (!video) return;

    video.loop = true;
    video.playsInline = true;
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.volume = 1;

    if (shouldMute) {
      video.defaultMuted = true;
      video.muted = true;
      video.setAttribute('muted', '');
    } else {
      video.defaultMuted = false;
      video.muted = false;
      video.removeAttribute('muted');
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function mountSection(root) {
    var viewport = root.querySelector('[data-grt-reel-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-grt-reel-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-grt-reel-dot]'));
    var audioToggles = Array.prototype.slice.call(root.querySelectorAll('[data-grt-reel-audio-toggle]'));
    var sectionInViewport = false;
    var soundEnabled = readStoredSoundPreference();
    var soundUnlocked = false;
    var forcedActiveIndex = null;
    var cleanupHandlers = [];

    if (!viewport || !cards.length) return;

    processInstagramEmbeds(root);

    function getCardIndex(card) {
      return cards.indexOf(card);
    }

    function getToggleState(cardIndex, activeIndex) {
      var isActiveCard = cardIndex !== -1 && cardIndex === activeIndex;
      var audioActive = isActiveCard && soundEnabled && soundUnlocked;
      var awaitingGesture = isActiveCard && soundEnabled && !soundUnlocked;

      return {
        audioActive: audioActive,
        awaitingGesture: awaitingGesture
      };
    }

    function getViewportActiveIndex() {
      var viewportStart = viewport.scrollLeft;
      var activeIndex = 0;
      var smallestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - viewportStart);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          activeIndex = index;
        }
      });

      return activeIndex;
    }

    function syncForcedActiveIndex() {
      if (forcedActiveIndex === null) return;
      if (getViewportActiveIndex() === forcedActiveIndex) {
        forcedActiveIndex = null;
      }
    }

    function updateDots(activeIndex) {
      if (!dots.length) return;

      dots.forEach(function (dot, index) {
        var isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateAudioToggles(activeIndex) {
      if (!audioToggles.length) return;

      audioToggles.forEach(function (toggle) {
        var cardIndex = getCardIndex(toggle.closest('[data-grt-reel-card]'));
        var toggleState = getToggleState(cardIndex, activeIndex);
        var audioLabel = toggle.querySelector('[data-grt-reel-audio-toggle-text]');

        toggle.dataset.audioState = toggleState.audioActive ? 'unmuted' : 'muted';
        toggle.setAttribute('aria-pressed', toggleState.audioActive ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          toggleState.audioActive
            ? 'Mute reel audio'
            : toggleState.awaitingGesture
              ? 'Tap reel to enable audio'
              : 'Enable reel audio'
        );

        if (audioLabel) {
          audioLabel.textContent = toggleState.audioActive
            ? 'Mute reel audio'
            : toggleState.awaitingGesture
              ? 'Tap reel to enable audio'
              : 'Enable reel audio';
        }
      });
    }

    function setSoundEnabled(nextValue) {
      soundEnabled = nextValue;
      writeStoredSoundPreference(nextValue);
    }

    function enableSoundFromGesture(targetCard) {
      var targetIndex = cards.indexOf(targetCard);
      var activeIndex = getActiveIndex();
      var targetVideo = targetCard ? targetCard.querySelector('video') : null;

      soundUnlocked = true;
      setSoundEnabled(true);
      forcedActiveIndex = targetIndex;

      cards.forEach(function (card, index) {
        var video = card.querySelector('video');
        if (!video) return;

        if (index === targetIndex) {
          attemptGesturePlay(video, false);
          return;
        }

        setVideoPlayback(video, false, true);
      });

      if (targetCard && targetIndex !== activeIndex) {
        viewport.scrollTo({
          left: targetCard.offsetLeft,
          behavior: 'smooth'
        });
        updateDots(targetIndex);
      }

      if (targetVideo) {
        targetCard.dataset.grtReelVisible = 'true';
      }

      syncPlayback();
    }

    function disableSound() {
      soundUnlocked = false;
      setSoundEnabled(false);
      syncPlayback();
    }

    function getActiveIndex() {
      syncForcedActiveIndex();
      return forcedActiveIndex !== null ? forcedActiveIndex : getViewportActiveIndex();
    }

    function syncDots() {
      var activeIndex = getActiveIndex();
      updateDots(activeIndex);
      updateAudioToggles(activeIndex);
    }

    function syncPlayback() {
      var activeIndex = getActiveIndex();

      cards.forEach(function (card, index) {
        var video = card.querySelector('video');
        var cardVisible = card.dataset.grtReelVisible === 'true';
        var shouldPlay = !document.hidden && sectionInViewport && cardVisible;
        var shouldMute = !(soundEnabled && soundUnlocked && shouldPlay && activeIndex === index);

        setVideoPlayback(video, shouldPlay, shouldMute);
      });

      updateAudioToggles(activeIndex);
    }

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          sectionInViewport = entry.isIntersecting && entry.intersectionRatio >= 0.2;
        });
        syncPlayback();
      },
      {
        threshold: [0, 0.2, 0.45]
      }
    );

    var cardObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.dataset.grtReelVisible = entry.isIntersecting && entry.intersectionRatio >= 0.6 ? 'true' : 'false';
        });
        syncPlayback();
      },
      {
        root: viewport,
        threshold: [0.2, 0.6, 0.9]
      }
    );

    sectionObserver.observe(root);
    cards.forEach(function (card) {
      card.dataset.grtReelVisible = 'false';
      cardObserver.observe(card);

      var video = card.querySelector('video');
      if (!video) return;

      var handleCanPlay = function () {
        syncPlayback();
      };

      video.addEventListener('canplay', handleCanPlay);
      cleanupHandlers.push(function () {
        video.removeEventListener('canplay', handleCanPlay);
      });

      var handleCardClick = function (event) {
        var clickTarget = event.target;
        var activeIndex = getActiveIndex();
        var cardIndex = getCardIndex(card);

        if (!clickTarget || clickTarget.closest('[data-grt-reel-audio-toggle]')) return;
        if (cardIndex === activeIndex && soundEnabled && soundUnlocked) {
          disableSound();
          return;
        }

        enableSoundFromGesture(card);
      };

      card.addEventListener('click', handleCardClick);
      cleanupHandlers.push(function () {
        card.removeEventListener('click', handleCardClick);
      });
    });

    dots.forEach(function (dot) {
      var handleClick = function () {
        var targetIndex = parseInt(dot.getAttribute('data-grt-reel-index') || '0', 10);
        var targetCard = cards[targetIndex];
        if (!targetCard) return;

        forcedActiveIndex = targetIndex;

        viewport.scrollTo({
          left: targetCard.offsetLeft,
          behavior: 'smooth'
        });
        updateDots(targetIndex);
      };

      dot.addEventListener('click', handleClick);
      cleanupHandlers.push(function () {
        dot.removeEventListener('click', handleClick);
      });
    });

    audioToggles.forEach(function (toggle) {
      var handleClick = function (event) {
        var targetCard = toggle.closest('[data-grt-reel-card]');
        var targetIndex = cards.indexOf(targetCard);
        var activeIndex = getActiveIndex();
        var toggleState = getToggleState(targetIndex, activeIndex);

        event.preventDefault();
        event.stopPropagation();

        if (targetIndex !== activeIndex && targetCard) {
          enableSoundFromGesture(targetCard);
        } else if (toggleState.audioActive) {
          disableSound();
        } else {
          soundUnlocked = true;
          setSoundEnabled(true);
          syncPlayback();
        }
      };

      toggle.addEventListener('click', handleClick);
      cleanupHandlers.push(function () {
        toggle.removeEventListener('click', handleClick);
      });
    });

    var handleViewportScroll = function () {
      syncDots();
      syncPlayback();
    };

    viewport.addEventListener('scroll', handleViewportScroll, { passive: true });
    cleanupHandlers.push(function () {
      viewport.removeEventListener('scroll', handleViewportScroll);
    });

    var handleResize = function () {
      syncDots();
      syncPlayback();
    };

    window.addEventListener('resize', handleResize);
    cleanupHandlers.push(function () {
      window.removeEventListener('resize', handleResize);
    });

    var handleVisibilityChange = function () {
      syncPlayback();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    syncDots();

    root._grtReelCleanup = function () {
      sectionObserver.disconnect();
      cardObserver.disconnect();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      cleanupHandlers.forEach(function (cleanup) {
        cleanup();
      });
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        setVideoPlayback(video, false);
        delete card.dataset.grtReelVisible;
      });
    };
  }

  function initSection(root) {
    if (!root || root.dataset.grtReelReady === 'true') return;
    root.dataset.grtReelReady = 'true';
    mountSection(root);
  }

  function destroySection(root) {
    if (!root) return;
    if (typeof root._grtReelCleanup === 'function') {
      root._grtReelCleanup();
      delete root._grtReelCleanup;
    }
    delete root.dataset.grtReelReady;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-grt-reel-section]');
    Array.prototype.forEach.call(roots, initSection);
  }

  function destroyAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-grt-reel-section]');
    Array.prototype.forEach.call(roots, destroySection);
  }

  window.addEventListener('load', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    destroyAll(event.target);
  });
})();
